export default {
  project: {
    key: 'String',
    name: 'String',
    projectTypeKey: 'String',
    projectTemplateKey: 'String',
    description: 'String',
    leadAccountId: 'String',
    url: 'String',
    assigneeType: 'String',
    avatarId: 'Number',
    issueSecurityScheme: 'Number',
    permissionScheme: 'Number',
    notificationScheme: 'Number',
    categoryId: 'Number',
  },
  property: {
    key: 'value',
  },
}
